import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';
import styles from './DashboardPanel.module.scss';

const EmptyIllustration = ({ variant }) => (
  <div className={`${styles.illustration} ${styles[variant]}`} aria-hidden="true">
    {variant === 'bars' && <><i /><i /><i /><i /><i /></>}
    {variant === 'line' && <svg viewBox="0 0 320 104"><path d="M8 84 L66 62 L120 72 L176 34 L230 48 L312 16" /></svg>}
    {variant === 'donut' && <i />}
  </div>
);

EmptyIllustration.propTypes = {
  variant: PropTypes.oneOf(['bars', 'line', 'donut']).isRequired,
};

const DashboardPanel = ({
  title,
  subtitle,
  note,
  action,
  tone,
  empty,
  emptyVariant,
  children,
}) => (
  <Paper
    component="section"
    elevation={0}
    className={`${styles.card} ${styles[tone] || ''}`}
  >
    <header className={styles.header}>
      <div>
        <h2 className={styles.title}>{title}</h2>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        {note && <p className={styles.note}>{note}</p>}
      </div>
      {action && <div className={styles.action}>{action}</div>}
    </header>
    {empty ? (
      <div className={styles.empty} data-testid={`dashboard-empty-${emptyVariant}`}>
        <EmptyIllustration variant={emptyVariant} />
        <p><IntlMessages id="search.health.preview.noData" /></p>
      </div>
    ) : (
      <div className={styles.body}>{children}</div>
    )}
  </Paper>
);

DashboardPanel.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  note: PropTypes.node,
  action: PropTypes.node,
  tone: PropTypes.oneOf(['searches', 'clickRate', 'zeroResults', 'clickEvents', 'warning']),
  empty: PropTypes.bool,
  emptyVariant: PropTypes.oneOf(['bars', 'line', 'donut']),
  children: PropTypes.node,
};

DashboardPanel.defaultProps = {
  subtitle: null,
  note: null,
  action: null,
  tone: 'searches',
  empty: false,
  emptyVariant: 'line',
  children: null,
};

export default DashboardPanel;
